export class EventListConfigModel {
  filters: {
    limit?: number,
    offset?: number
  } = {};
}
